import { render } from "./kontainerDriver.vue?vue&type=template&id=b6598bc2"
import script from "./kontainerDriver.vue?vue&type=script&lang=js"
export * from "./kontainerDriver.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__